export const getDescriptionFromError = err => {
  const message = (err.response && err.response.data && err.response.data.message) || err.message;
  if (message.length && typeof message[0] === 'object' && message[0].field && message[0].message) {
    return message.reduce((acc, msg) => (acc + `${msg.field} ${msg.message}`), '');
  } else if (typeof message === 'string') {
    return message;
  }
  return 'An error occurred';
};

export function handleFormErrorNotification(err, values, setFields, notification) {
  const message = (err.response && err.response.data && err.response.data.message) || err.message;
  let description = 'An unexpected error occurred';
  if (message.length && typeof message[0] === 'object' && message[0].field && message[0].message) {
    const fields = message.reduce((a, c) => ({
      ...a,
      [c.field]: {value: values[c.field], errors: [new Error(c.message)]}
    }), {});
    setFields(fields);
    return;
  } else if (typeof message === 'string') {
    description = message;
  }
  notification.error({message: 'Failed', description});
}



// WEBPACK FOOTER //
// ./src/utils/errors.js